module.exports = __webpack_public_path__ + "static/media/evening.824d1ba5.png";